import EmailInput from '@components/FormFields/EmailInput';
import InputField from '@components/FormFields/InputField';
import Spacer from '@components/Spacer';
import { Dispatch, SetStateAction } from 'react';

type Props = {
  email: string;
  name: string;
  hasInitialEmail: boolean;
  hasInitialName: boolean;
  isRouting: boolean;
  setEmail: Dispatch<SetStateAction<string>>;
  setEmailError: Dispatch<SetStateAction<string | null>>;
  setName: Dispatch<SetStateAction<string>>;
};

const PersonalInfo: React.FC<Props> = ({
  hasInitialEmail,
  hasInitialName,
  email,
  name,
  isRouting,
  setEmail,
  setEmailError,
  setName,
}) => {
  const hasAllInitialPersonalInfo = hasInitialEmail && hasInitialName;
  return (
    <>
      <span className='body-sm-bold'>Personal Information</span>
      <Spacer size={hasAllInitialPersonalInfo ? 0 : 16} />
      {hasAllInitialPersonalInfo
        ? (
          <>
            <span className={'caption'}>{`${name}, ${email}`}</span>
            <Spacer size={24}/>
          </>
        )
        : (
          <>
            {!isRouting && (
              <>
                <EmailInput
                  disabled={hasInitialEmail}
                  id="email"
                  value={email}
                  onChange={setEmail}
                  onError={setEmailError}
                  label="Email"
                  required
                  placeholder="Enter your email address"
                />
                <Spacer size={16}/>
                <InputField
                  id="name"
                  label="Name"
                  name="name"
                  values={{ name }}
                  placeholder="Enter your name"
                  onChange={setName}
                  autoComplete={'name'}
                />
                <Spacer size={16}/>
              </>
            )}
          </>
        )
      }
    </>
  );
};

export default PersonalInfo;
